import styled from '@emotion/styled'
import { Accordion, AccordionProps } from '@mui/material'

import { lightTheme } from '~createTheme'

interface StyledAccordionProps extends AccordionProps {}

const StyledAccordion = styled(
  Accordion,
  {},
)<StyledAccordionProps>(({}) => {
  return {
    backgroundColor: lightTheme.palette.background.default,
    borderBottom: `1px solid ${lightTheme.palette.divider}`,
    color: lightTheme.palette.text.primary,
    boxShadow: 'none',
    borderRadius: '4px',
    '&:before': {
      display: 'none',
    },
    '&.Mui-expanded': {
      margin: '0',
    },
  }
})

export default StyledAccordion
